import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeProvider";

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      aria-label="Toggle theme"
      className="flex h-10 w-10 items-center justify-center border-2 border-border text-foreground transition-colors hover:border-primary hover:text-primary"
    >
      {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
};
